Alerts = require 'views/lib/alerts'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
removeGuestFromTeamBoardsTemplate = require 'views/templates/popover_remove_guest_from_team_boards'
l = require 'lib/localize'
localizeCount = require 'lib/localize-count'
localizeServerError = require 'lib/localize-server-error'

module.exports = class RemoveGuestFromTeamBoards extends View
  viewTitleKey: 'remove from boards'

  events:
    'click .js-confirm-remove-from-team-boards': 'confirmRemoveFromBoards'

  render: ->
    { teamBoardCount } = @options

    org = @options.parent
    isOnlyAdminBoardNames = org.boardList.filter (board) =>
      board.isMember(@model) && board.ownedByMember(@model) && board.adminList.length == 1
    .map (board) =>
      board.get('name')

    @$el.html(removeGuestFromTeamBoardsTemplate(
      {
        fullName: @model.get('fullName'),
        isOnlyAdminBoardNames,
        teamBoardCount,
        boardsRemainingCountLocalized: localizeCount('team boards', teamBoardCount - isOnlyAdminBoardNames.length),
        teamBoardCountLocalized: localizeCount('team boards', teamBoardCount)
      }
    ))
    @

  showError: (message) ->
    errorMessage = localizeServerError(message)
    Alerts.showLiteralText(errorMessage, 'error', 'alert', 5000)

  confirmRemoveFromBoards: (e) ->
    Util.preventDefault(e)

    @$('.js-confirm-remove-from-team-boards').attr('disabled', true).addClass('disabled')

    org = @options.parent
    boards = org.boardList.filter (board) =>
      board.getMembershipFor(@model) && (!board.ownedByMember(@model) || (board.ownedByMember(@model) && board.adminList.length > 1))

    boards.forEach (board) =>
      board.removeMember(@model)

    if boards.length
      Alerts.show('guest removed from team boards', 'warning', 'info', 3000)
      org.trigger('change:memberships')

    PopOver.hide()



// WEBPACK FOOTER //
// ./app/scripts/views/organization/remove-guest-from-team-boards.coffee